<template>
  <div class="min-h-full text-app-color flex flex-col px-15 font-Relative" :class="isDarkMode ? 'bg-primary' : 'bg-grey-450'">
    <LogoModule class="pt-30 md:pt-25 md:pl-25 md:absolute" />

    <div class="w-full mx-auto mt-30 md:m-auto max-w-600 pb-60 md:pt-60">
      <div class="m-15">
        <Step1
          v-if="step === 1"
          v-model="user"
          :has-invite="hasInvite"
          @next="next"
          @setExistingAccount="setExistingAccount"
          @nextToStep3="nextToStep3"
          @nextToStep4="nextToStep4"
        />

        <Step2 v-if="step === 2" v-model="signUpType" :user="user" :has-account="hasAccount" @next="next" @nextToStep4="nextToStep4" />
        <Step3
          v-if="step === 3"
          v-model="user"
          :has-invite="hasInvite"
          :type="signUpType"
          @next="next"
          @nextToStep5="nextToStep5"
        />

        <Step4Personal v-if="step === 4 && signUpType === 'personal'" :has-account="hasAccount" :user="user" />
        <Step4Team v-if="step === 4 && signUpType === 'teams'" v-model="team" :user="user" @next="next" />

        <Step5Team
          v-if="step === 5"
          :team="team"
          :user="user"
          :has-invite="hasInvite"
          @next="next"
        />
        <Step6Team v-if="step === 6" :user="user" :team="team" :has-account="hasAccount" @next="next" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

import LogoModule from '@/components/shared/LogoModule'

import Step1 from '@/components/auth/Step1'
import Step2 from '@/components/auth/Step2'
import Step3 from '@/components/auth/Step3'
import Step4Personal from '@/components/auth/Step4Personal'
import Step4Team from '@/components/auth/Step4Team'
import Step5Team from '@/components/auth/Step5Team'
import Step6Team from '@/components/auth/Step6Team'

export default defineComponent({
  name: 'SignUpPersonal',

  components: {
    LogoModule,
    Step1,
    Step2,
    Step3,
    Step4Personal,
    Step4Team,
    Step5Team,
    Step6Team
  },

  setup () {
    const { getters } = useStore()
    const route = useRoute()
    const step = ref(1)
    const signUpType = ref('')

    const user = ref({
      email: '',
      password: '',
      firstName: '',
      lastName: ''
    })

    const team = ref({
      name: '',
      logo: ''
    })

    const hasAccount = ref('')
    const hasInvite = ref('')

    onMounted(() => {
      hasInvite.value = !!route.query.invite

      if (hasInvite.value) {
        user.value.email = route.query.email
        team.value.name = route.query.teamName
      }
    })

    const isDarkMode = computed(() => getters.isDarkMode)

    function next () {
      step.value++
    }

    const oppositeAccount = {
      teams: 'personal',
      personal: 'teams'
    }

    function nextToStep4 (value) {
      step.value = 4
      // signUpType.value = oppositeAccount[value]
      // hasAccount.value = value
    }

    function nextToStep3 (value) {
      step.value = 3
      signUpType.value = 'teams'
    }

    function nextToStep5 (value) {
      step.value = 5
    }

    function setExistingAccount (value) {
      step.value++
      signUpType.value = oppositeAccount[value]
      hasAccount.value = value
    }

    return {
      // data
      step,
      team,
      user,
      signUpType,
      hasAccount,
      hasInvite,
      // computed
      isDarkMode,
      // function
      next,
      nextToStep3,
      nextToStep4,
      nextToStep5,
      setExistingAccount
    }
  }
})
</script>
